import * as Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';

import { BaseComponent } from '@pixelart/component-handler';

export class Gallery extends BaseComponent {
    protected GALLERY_SELECTOR: string = '.gallery__swiper';
    protected ITEM_SELECTOR: string = '.gallery__slide';
    protected BTN_NEXT_SELECTOR: string = '.gallery__button-next';
    protected BTN_PREV_SELECTOR: string = '.gallery__button-prev';
    private swiper: Swiper;

    constructor(element: Element) {
        super(element);
    }

    public init() {
        this.initGallery();
    }

    public initGallery() {
        this.swiper = new Swiper(this.GALLERY_SELECTOR, {
            breakpoints: {
                768: {
                    loopedSlides: 2,
                    slidesPerView: 1,
                },
            },
            centeredSlides: true,
            grabCursor: true,
            lazyLoading: true,
            lazyLoadingInPrevNext: true,
            loop: true,
            loopedSlides: 3,
            nextButton: this.BTN_NEXT_SELECTOR,
            preloadImages: false,
            prevButton: this.BTN_PREV_SELECTOR,
            slideToClickedSlide: true,
            slidesPerView: 'auto',
            spaceBetween: 1,
            watchSlidesVisibility: true,
        });
    }

    public destroy() {
        this.swiper.destroy(true, true);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/gallery/gallery.class.ts